import React from 'react';


const Test = () => {
	return (
		<div style={{ padding: '100px' }}>
    </div>
  );
};

export default Test;
